module.exports = __webpack_public_path__ + "img/logo-loverfans-white.4790e1c5.svg";